/**
 * Branded header for the shareable-link page.
 *
 * Three rendering branches by branding shape:
 *   { clientName, clientLogoUrl }   → client logo prominent + name in H1,
 *                                     small "Powered by GreenCharge" footer.
 *   { clientName, clientLogoUrl=null } → client name in H1, no logo,
 *                                        "Powered by GreenCharge" footer.
 *   { clientName=null }              → default GreenCharge brand bar.
 *
 * Used at the top of the SharedOnboardingFlow form AND on every terminal
 * screen (expired / disabled / archived / full) so the customer sees a
 * consistent brand experience end-to-end.
 */

import React from 'react';
import GreenChargeLogo from '../Common/GreenChargeLogo.jsx';

function SharedLinkBrandHeader({ branding, tag }) {
  const clientName = branding?.clientName || null;
  const clientLogoUrl = branding?.clientLogoUrl || null;

  // No client at all → plain GreenCharge brand bar matching the personal
  // invite flow. Optional `tag` ("Onboarding") sits next to the wordmark.
  if (!clientName) {
    return (
      <div className="ob-brandbar">
        <GreenChargeLogo variant="wordmark" />
        {tag && <span className="ob-brandbar__tag">{tag}</span>}
      </div>
    );
  }

  // Client present (with or without logo).
  return (
    <div className="ob-brandbar ob-brandbar--client">
      {clientLogoUrl ? (
        <img
          src={clientLogoUrl}
          alt={`${clientName} logo`}
          className="ob-brandbar__client-logo"
          style={{ maxHeight: 56, maxWidth: 200, objectFit: 'contain' }}
        />
      ) : (
        <span className="ob-brandbar__client-name">{clientName}</span>
      )}
      <span className="ob-brandbar__powered-by">
        <small>Powered by</small>
        <GreenChargeLogo variant="wordmark" style={{ height: 20, maxWidth: 96 }} />
      </span>
    </div>
  );
}

export default SharedLinkBrandHeader;
